namespace TabAurous.Purchase {
    export namespace PurchaseReturnPostingService {
        export const baseUrl = 'Purchase/PurchaseReturnPosting';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<Common.MasterTransaction>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/PurchaseReturnPosting/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>PurchaseReturnPostingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
